module.exports = __webpack_public_path__ + "img/AccessCRM-initial-splash.01bbb1f8.png";